export default "__VITE_ASSET__CTqdWM8R__"